<template>
  <div class="w-100">
		<Mobile 
      ref="mobile_view"
			v-if="is_mobile_view"
      :data_parent="data_to_child"
      :submit_form="submitForm"
      @selectPayment="selectPayment"
      @detailTAC="toggleModalTac"
      @toggleAcceptTAC="acceptAndOpenDetailTAC"
			>
		</Mobile>
		<Desktop 
      ref="desktop_view"
      :data_parent="data_to_child"
      :submit_form="submitForm"
      @selectPayment="selectPayment"
      @detailTAC="toggleModalTac"
      @toggleAcceptTAC="acceptAndOpenDetailTAC"
			v-else
			>
		</Desktop>

    <!-- TERMS & CONDITIONS -->
    <b-modal ref="tac" title="Terms & Conditions" size="lg">
      <div class="w-100 p-4">
        <div class="html-desc body-2-1" v-html="getMerchant.terms_and_conditions"></div>
      </div>
      <template slot="modal-footer">
        <div class="w-100">
          <div class="row slim-grid-row justify-content-center">
            <div class="col-12 col-md-4">
              <button class="g-btn g-btn-lg g-btn-primary w-100" @click="acceptTAC()">Accept</button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- DEPOSIT 0 -->
    <b-modal ref="deposit_0" hide-header no-close-on-backdrop no-close-on-esc>
      <div class="w-100 pt-4 pb-3 px-5 text-center">
        <p class="mb-0 heading-6-1">Are you sure to create this transaction?</p>
        <p class="mb-0 body-1-3">Make sure you have chosen a product that suits your needs</p>
      </div>
      <template slot="modal-footer">
        <div class="w-100">
          <div class="row slim-grid-row">
            <div class="col-5">
              <button class="g-btn g-btn-lg g-btn-dark w-100" @click="cancelDeposit">Cancel</button>
            </div>
            <div class="col-7">
              <state-button variant="primary" block size="lg" :click="submitForm">Continue</state-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    
    <!-- EMPTY CART -->
    <popup-detail 
      id_ref="empty_trx"
      direction="bottom" 
      :show="show_empty"
      use_max_size
      wrapper_size="mobile"
      use_footer
      no_close_backdrop
      @close="toggleEmpty">
      <template v-slot:body>
        <div class="py-5 px-4 text-center">
          <img src="../../assets/img/icon/namaste.png" class="mb-4" width="200">
          <p class="mb-0 body-2-2 text-18 text-green font-extrabold">{{$t('ticket-cart.empty-cart.title')}}</p>
          <p class="mb-2 body-2-2">{{$t('ticket-cart.empty-cart.message')}}</p>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3">
          <router-link :to="`/${getMerchant.code}`">
            <button 
              class="ga-btn-primary-lg" >
              Select Ticket
            </button>
          </router-link>
        </div>
      </template>
    </popup-detail>

    <form :action="dkpayload.URL" method="post" id="dkpayform2018" name="dkpayform2018" ref="FormDKload">
      <input name="MALLID" type="hidden" v-model="dkpayload.MALLID" >
      <input name="BASKET" type="hidden" v-model="dkpayload.BASKET" >
      <input name="CHAINMERCHANT" type="hidden" v-model="dkpayload.CHAINMERCHANT" >
      <input name="AMOUNT" type="hidden" v-model="dkpayload.AMOUNT" >
      <input name="PURCHASEAMOUNT" type="hidden" v-model="dkpayload.PURCHASEAMOUNT" >
      <input name="TRANSIDMERCHANT" type="hidden" v-model="dkpayload.TRANSIDMERCHANT" >
      <input name="WORDS" type="hidden" v-model="dkpayload.WORDS" >
      <input name="CURRENCY" type="hidden" v-model="dkpayload.CURRENCY" >
      <input name="PURCHASECURRENCY" type="hidden" v-model="dkpayload.PURCHASECURRENCY" >
      <input name="COUNTRY" type="hidden" v-model="dkpayload.COUNTRY" >
      <input name="SESSIONID" type="hidden" v-model="dkpayload.SESSIONID" >
      <input name="PAYMENTCHANNEL" type="hidden" v-model="dkpayload.PAYMENTCHANNEL" >
      <input name="REQUESTDATETIME" type="hidden" v-model="dkpayload.REQUESTDATETIME" >
      <input name="NAME" type="hidden" v-model="dkpayload.NAME" >
      <input name="EMAIL" type="hidden" v-model="dkpayload.EMAIL" >
      <input name="ADDRESS" type="hidden" v-model="dkpayload.ADDRESS" >
      <input name="MOBILEPHONE" type="hidden" v-model="dkpayload.MOBILEPHONE" >
    </form>
	</div>
</template>

<script>
  import Desktop from './TicketCartDesktop'; 
	import Mobile from './TicketCartMobile';
  import {mapGetters,mapMutations,mapActions} from 'vuex';
  import {get,post} from '@/services/index.js'
  import Form from '../../base'
  import moment from 'moment'
  
  export default {
    components:{
      Desktop,
      Mobile
    },
    data() {
      return {
        is_load: true,
        payment_method: {
          list: [],
          selected: {}
        },
        show_empty: false,
        dkpayload : new Form({
            MALLID : '',
            BASKET : '',
            CHAINMERCHANT : '',
            AMOUNT : '',
            PURCHASEAMOUNT : '',
            TRANSIDMERCHANT : '',
            WORDS : '',
            REQUESTDATETIME : '',
            CURRENCY : '',
            PURCHASECURRENCY : '',
            SESSIONID : '',
            PAYMENTCHANNEL: '',
            NAME : '',
            EMAIL : '',
            ADDRESS : '',
            COUNTRY : '',
            URL : '',
        }),
        show_xendit_cc_form: false,
        tx_payment: {},
        validation: {
          visitor: true,
          payment: true,
          push: ''
        },
        terms_and_conditions: false,
        tac_opened: 0,
        pass_deposit_0_warning: false
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getTicketCart',
        'isLoggedIn',
        'getTicketCartSubTotal',
        'getTicketSubTotalPrice',
        'getTicketDiscountPrice',
        'getTicketTotalPrice']),
      visitor_data(){
        let return_data = {
          name: '',
          email: '',
          phone_number: ''
        }
        if(Object.keys(this.getTicketCart.visitor_details).length > 0){
          let vuex_data = this.getTicketCart.visitor_details
          if(vuex_data.first_name != ''){
            return_data.name = `${this.$capitalize(vuex_data.title)}. ${vuex_data.first_name}`
            if(this.$isNotEmpty(vuex_data.last_name)) return_data.name += ` ${vuex_data.last_name}`
          }
          return_data.email = vuex_data.email
          return_data.phone_number = vuex_data.phone_number
        }

        return return_data
      },
      is_mobile_view(){
				return window.innerWidth > 768 ? false : true
			},
      total_ticket_qty(){
        return this.getTicketCart.ticket_details.length
      },
      payment_surcharge(){
				let total = 0
				if(this.payment_method.selected.id){
					if(this.payment_method.selected.surcharge_type == 'PERCENT'){
						total = (this.getTicketTotalPrice/100)*this.payment_method.selected.surcharge_value
					}else{
						total = this.payment_method.selected.surcharge_value
					}

          if(this.payment_method.selected.bank_name == 'XENDIT' && this.payment_method.selected.payment_method == 'CREDIT_CARD') {
            total = Math.ceil(total)
          }
				}

				return total
			},
      total_payment(){
        return this.getTicketTotalPrice + this.payment_surcharge
      },
      addt_info_ticket(){
        let data = []
        this.getTicketCart.ticket_details.forEach(ticket=>{
          ticket.variant.forEach(variant=>{
            if(variant.data.collect_additional_information){
              for(let i = 0; i < variant.qty; i++){
                let addt_data = {
                  id: 0,
                  id_cart: variant.data.id_cart,
                  product_name: ticket.ticket.name,
                  variant_name: variant.data.variant_name,
                  additional_information: []
                }
                let additional_information = this.$deepCopy(variant.data.additional_information)
                let addt_form = additional_information.map(x=>{
                  x.value = ''
                  x.error = false
                  return x
                })
                addt_data.id = data.length+1
                addt_data.additional_information = addt_form
                data.push(addt_data)
              }
            }
          })
        })
        return data
      },
      data_to_child(){
        return {
          is_load: this.is_load,
          payment_method: this.payment_method.list,
          visitor_data: this.visitor_data,
          payment_surcharge: this.payment_surcharge,
          total_payment: this.total_payment,
          validation: this.validation,
          show_xendit_cc_form: this.show_xendit_cc_form,
          tx_payment: this.tx_payment,
          terms_and_conditions: this.terms_and_conditions,
          addt_info_ticket: this.addt_info_ticket
        }
      }
    },
    watch:{
      total_ticket_qty(){
        if(this.total_ticket_qty == 0){
          this.show_empty = true;
        }
      }
    },
    mounted(){
      if(this.getTicketCart.ticket_details.length == 0){
        this.show_empty = true
      }else{
        this.loadFirstData()
      }
    },
    methods:{
      ...mapMutations(['ticketSetGuest','ticketSetPaymentDoku']),
      ...mapActions(['ticketResetItemCart']),
      toggleEmpty(){
        this.show_empty =!this.show_empty
      },
      loadFirstData(){
        this.is_load = true
        let func_exe = []
        if(this.isLoggedIn) func_exe.push(this.getUserProfile())
        func_exe.push(this.loadPaymentMethod())
        Promise.all(func_exe).finally(()=>{
          this.is_load = false
        })
      },
      getUserProfile(){
        return new Promise((success,fail)=>{
          get("BASE","auth/profile").then(response=>{
            let res = response.data.user
            let vuex_data = this.$deepCopy(this.getTicketCart.customer_details)
            let params = {
              field: 'customer_details',
              data: []
            }
            if(!this.$isNotEmpty(vuex_data.first_name)){
              params.data.push({
                key: 'first_name',
                value: res.first_name
              })
            }
            if(!this.$isNotEmpty(vuex_data.last_name)){
              params.data.push({
                key: 'last_name',
                value: res.last_name
              })
            }
            if(!this.$isNotEmpty(vuex_data.email)){
              params.data.push({
                key: 'email',
                value: res.email
              })
            }
            if(!this.$isNotEmpty(vuex_data.phone_number)){
              params.data.push({
                key: 'phone_number',
                value: res.phone
              })
            }
            if(!this.$isNotEmpty(vuex_data.title)){
              params.data.push({
                key: 'title',
                value: res.prefix_name
              })
            }
            if(params.data.length > 0){
              this.ticketSetGuest(params)
            }
            success()
          })
        })
      },
      loadPaymentMethod(){
        return new Promise((success,fail)=>{
          this.payment_method.list = []
          const apiEndPoint = `merchant/${this.getMerchant.code}/payment-method`
          get("CORE_HOTEL",apiEndPoint, {module: 'ticket'}).then(response=>{
            let res = response.data
            if(res.success){
              this.payment_method.list = res.data.map(payment => {
                const { channel, pg_company } = payment;
                payment.payment_method = payment.channel
                payment.payment_channel = payment.channel
                payment.bank_name = payment.pg_company
                return payment;
              })
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      selectPayment(pm){
        this.payment_method.selected = pm
      },
      submitForm(){
        return new Promise((success,fail)=>{
          this.validation.visitor = true
          this.validation.payment = true
          this.validation.push = ''
          
          let viewtype_function = this.is_mobile_view ? this.$refs.mobile_view : this.$refs.desktop_view
          viewtype_function.validateCustomer().then(()=>{

            let nextStep = (addt_data = {}) => {
              if(this.total_payment > 0 && Object.keys(this.payment_method.selected).length == 0){
                this.validation.payment = false
                fail()
              }else{
                if(this.total_payment == 0 && !this.pass_deposit_0_warning){
                  this.pass_deposit_0_warning = true
                  this.$refs.deposit_0.show()
                  success()
                }else{
                  this.submitInquiry(addt_data).then(inquiry_res=>{
                    this.submitPayment(inquiry_res.tx_order_id).then(payment_res=>{
                      success()
                    }).catch(payment_err=>{
                      this.validation.push = payment_err
                      fail()
                    })
                  }).catch(inquiry_err=>{
                    this.validation.push = inquiry_err
                    fail()
                  })
                }
              }
            }
            
            let collectAddtInformation = () => {
              if(this.addt_info_ticket.length > 0){
                viewtype_function.validateAddtInformation().then(addt_ticket_res=>{
                  nextStep(addt_ticket_res)
                }).catch(()=>{
                  fail()
                })
              }else{  
                nextStep()
              }
            }
            
            if(this.getTicketCart.ticket_owner == 'someone'){
              viewtype_function.validateVisitor().then(()=>{
                collectAddtInformation()
              }).catch(()=>{
                this.validation.visitor = false
                fail()
              })
            }else{
              collectAddtInformation()
            }

          }).catch(()=>{
            fail()
          })
        })
      },
      submitInquiry(addt_data){
        return new Promise((success,fail)=>{
          let getGuestData = (data) =>{
            let return_data = this.$deepCopy(data)
            
            return_data.gender = return_data.title == '' ? '' : return_data.title == 'MR' ? 'MALE' : 'FEMALE'
            return_data.address = ''
            
            return return_data
          }
          let guest = getGuestData(this.getTicketCart.customer_details)
          
          let params = {
            merchant_id: this.getMerchant.id,
            visit_date: moment(this.getTicketCart.visit_date).format("YYYY-MM-DD"),
            visitor_details: guest,
            customer_details: guest,
            ticket_details: [],
            promo_code: this.getTicketCart.promo_code
          }
          
          if (this.getTicketCart.ticket_owner == 'someone') params.visitor_details = getGuestData(this.getTicketCart.visitor_details)
          
          this.getTicketCart.ticket_details.forEach(product=>{
            product.variant.forEach(variant=>{
              let ticket_params = {
                id: variant.data.id_cart,
                qty: variant.qty,
                additional_information: []
              }
              if(variant.data.collect_additional_information){
                let variant_addt_data = addt_data.filter(x=>x.id_cart == variant.data.id_cart)
                variant_addt_data.forEach(addt_item=>{
                  let addt_item_clone = this.$deepCopy(addt_item)
                  let addt_item_final = addt_item_clone.additional_information.map(x=>{
                    delete x.error
                    delete x.input_type
                    delete x.is_required
                    return x
                  })
                  ticket_params.additional_information.push(addt_item_final)
                })
              }
              params.ticket_details.push(ticket_params)
            })
          })
          
          post("CORE","tx-ticket-inquiry",params).then(response=>{
            let res = response.data
            if (res.success) {
              success(res.data)
            }else{
              fail(res.message)
            }
          })
          
        })
      },
      submitPayment(tx_order_id){
        return new Promise((success,fail)=>{
          let params = {
            id: this.payment_method.selected.id,
            payment_method: this.payment_method.selected.payment_method,
            bank_name: this.payment_method.selected.bank_name,
            payment_channel: this.payment_method.selected.payment_method
          }

          if(this.payment_method.selected.payment_method == 'VIRTUAL_ACCOUNT'){
            if(this.payment_method.selected.bank_name == 'BPD_BALI') params.payment_channel = "VA_BPD_BALI"
            else if(this.payment_method.selected.bank_name == 'DOKU') params.payment_channel = "VA_ATM_BERSAMA"
          }

          post("CORE","tx-ticket-payment",{
            tx_order_id:tx_order_id,
            payment_details: this.total_payment > 0 ? params : null,
            promo_code: this.getTicketDiscountPrice > 0 ? this.getTicketCart.promo_code : ''
          }).then(response=>{
            let res = response.data
            if(res.success){
              if(this.payment_method.selected.bank_name == 'XENDIT' && this.payment_method.selected.payment_method == 'CREDIT_CARD'){
              this.tx_payment = res.payment
              this.show_xendit_cc_form = true
            }else{
              this.ticketResetItemCart("with_date")
              if(this.$isPivotPayment(this.payment_method.selected.bank_name)){
                this.$openLink(this.$getPivotPaymentUrl(res.payment))
              }else if(this.payment_method.selected.bank_name == 'DOKU' && this.payment_method.selected.payment_method == 'CREDIT_CARD'){
                if(this.payment_method.selected.pg_mode == 'PG_HOSTED'){
                  this.dkpayload.MALLID = res.payment.form.MALLID;
                  this.dkpayload.BASKET = res.payment.form.BASKET;
                  this.dkpayload.CHAINMERCHANT = res.payment.form.CHAINMERCHANT;
                  this.dkpayload.AMOUNT = res.payment.form.AMOUNT;
                  this.dkpayload.PURCHASEAMOUNT = res.payment.form.PURCHASEAMOUNT;
                  this.dkpayload.TRANSIDMERCHANT = res.payment.form.TRANSIDMERCHANT;
                  this.dkpayload.WORDS = res.payment.form.WORDS;
                  this.dkpayload.REQUESTDATETIME = res.payment.form.REQUESTDATETIME;
                  this.dkpayload.CURRENCY = res.payment.form.CURRENCY;
                  this.dkpayload.PURCHASECURRENCY = res.payment.form.PURCHASECURRENCY;
                  this.dkpayload.SESSIONID = res.payment.form.SESSIONID;
                  this.dkpayload.PAYMENTCHANNEL = res.payment.form.PAYMENTCHANNEL;
                  this.dkpayload.NAME = res.payment.form.NAME;
                  this.dkpayload.EMAIL = res.payment.form.EMAIL;
                  this.dkpayload.ADDRESS = res.payment.form.ADDRESS;
                  this.dkpayload.MOBILEPHONE = res.payment.form.MOBILEPHONE;
                  this.dkpayload.COUNTRY = res.payment.form.COUNTRY;
                  this.dkpayload.URL = res.payment.payment_url;
                  this.$nextTick(() => {
                      this.$refs.FormDKload.submit();
                  });
                }else{
                  this.ticketSetPaymentDoku({
                    type: 'CREDIT_CARD',
                    data: res.payment
                  })
                  this.$router.push({
                    path: '/'+this.getMerchant.code+'/payment/'+res.tx_order_id
                  })
                }
              }else{
                this.$router.push({
                  path: '/'+this.getMerchant.code+'/payment/'+res.tx_order_id
                })
              }
            }
            }else{
              fail(res.message)
            }
          })
          
        })
      },
      acceptTAC(){
        this.terms_and_conditions = true
        this.toggleModalTac(false)
      },
      declineTAC(){
        this.terms_and_conditions = false
      },
      acceptAndOpenDetailTAC(){
        this.terms_and_conditions = !this.terms_and_conditions
        if(this.terms_and_conditions && this.tac_opened == 0) this.toggleModalTac()
        else (this.toggleModalTac(false))
      },
      toggleModalTac(show=true){
        if(show){
          this.$refs.tac.show()
          this.tac_opened++
        }
        else this.$refs.tac.hide()
      },
      cancelDeposit(){
        this.$refs.deposit_0.hide()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/ticket/TicketCart.vue